import { render, staticRenderFns } from "./NotificationPortalDetail.vue?vue&type=template&id=12e5e4de&"
import script from "./NotificationPortalDetail.vue?vue&type=script&lang=ts&"
export * from "./NotificationPortalDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports